import React, { useEffect, useState } from 'react';
import { Button, message } from 'antd';
import apis from '../../../../api';
import { toList } from '../../utils';

export default ({ item = {} }) => {
  const [currItem, setCurrItem] = useState({});

  /* eslint-disable */
  useEffect(() => {
    item.firstDocId &&
      apis
        .HelpGetDocument({ id: item.firstDocId })
        .then((res) => {
          if (res && res.ret === '0') {
            setCurrItem(Object.assign({}, res.data));
          } else {
            message.error(res.msg);
          }
        })
        .catch((err) => {
          message.error(err);
        });
  }, [item.firstDocId]);
  /* eslint-enable */

  return (
    <div className="help-center-hot-title" onClick={() => window.open(toList(item))}>
      <div className="help-center-hot-name">热门专题</div>
      {currItem.title ? <div className="desc">{currItem.title}</div> : <div className="desc">快速上手，解决方案</div>}
      <Button type="primary" size="small">
        立即查看
      </Button>
    </div>
  );
};
